import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// CSS styles for DatePicker borders
const datePickerStyles = `
  .date-picker-with-border .react-datepicker__input-container input {
    border: 1px solid #ccc !important;
    border-radius: 4px !important;
    padding: 8px 12px !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }
  
  .date-picker-with-border .react-datepicker__input-container input:focus {
    border-color: #007bff !important;
    outline: none !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
  }
`;

function CreateReportAttachmentsPopup(props: any) {
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [showError, setShowError] = useState(false);

  const formatDateToYYYYMMDD = (date: Date | null) => {
    if (!date) return "";

    try {
      // Create a new date to avoid timezone issues
      const localDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000
      );
      const isoString = localDate.toISOString();
      const dateOnly = isoString.split("T")[0];

      // Double check the format with regex
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(dateOnly)) {
        // Fallback method
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }

      return dateOnly;
    } catch (error) {
      // Ultimate fallback
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
  };

  const handleSubmit = () => {
    if (!fromDate || !toDate) {
      setShowError(true);
      return;
    }

    // Validate that fromDate is not later than toDate
    if (fromDate > toDate) {
      setShowError(true);
      return;
    }

    setShowError(false);

    // Format dates to YYYY-MM-DD format for the API
    const startDate = formatDateToYYYYMMDD(fromDate);
    const endDate = formatDateToYYYYMMDD(toDate);

    // Validate the format before sending
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(startDate) || !dateRegex.test(endDate)) {
      console.error("Invalid date format:", {
        start_date: startDate,
        end_date: endDate,
      });
      setShowError(true);
      return;
    }

    console.log("Sending dates:", { start_date: startDate, end_date: endDate });

    props.handleCreateAttachmentReport({
      start_date: startDate,
      end_date: endDate,
    });
  };

  const handleFromDateChange = (date: Date | null) => {
    setFromDate(date);
    setShowError(false);
  };

  const handleToDateChange = (date: Date | null) => {
    setToDate(date);
    setShowError(false);
  };

  return (
    <>
      <style>{datePickerStyles}</style>
      <Modal isOpen={props.isOpen}>
        <ModalHeader>Select Date Range</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <div
              style={{
                display: "flex",
                gap: "16px",
                alignItems: "flex-end",
                flexWrap: "wrap"
              }}
            >
              <div style={{ flex: "1", minWidth: "200px" }} className="date-picker-with-border">
                <label className="form-label">Start Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="d MMMM, yyyy"
                  placeholderText="Select Start Date"
                  className="custom-form-control form-control"
                  maxDate={toDate || undefined}
                />
              </div>

              <div style={{ flex: "1", minWidth: "200px" }} className="date-picker-with-border">
                <label className="form-label">End Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="d MMMM, yyyy"
                  placeholderText="Select End Date"
                  className="custom-form-control form-control"
                  minDate={fromDate || undefined}
                />
              </div>
            </div>
          </div>

          {showError && (
            <span className="form-error" style={{ display: "block", marginTop: "12px" }}>
              * From date and to date are required and from date should not be
              later than to date
            </span>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            className="ascent-button ascent-button--header-buttons ascent-button--primary"
            onClick={props.handleCancelModal}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className={`ascent-button ascent-button--header-buttons ascent-button--secondary`}
          >
            Download
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default CreateReportAttachmentsPopup;